/**
 * Ids de selects (`v-select` / `v-autocomplete`) que trafegam ora como número,
 * ora como string.
 *
 * As stores publicam as opções com `value: String(id)` (`useCompanyStore`,
 * `useHealthUnitStore`), enquanto quem guarda o valor selecionado costuma ter o
 * id como número — filtros (`FilterStates`) e formulários pré-preenchidos a
 * partir da API. O comparador padrão do Vuetify é estrito (`deepEqual`), então
 * `8 !== '8'`: sem tolerância o componente não acha o item do valor
 * selecionado, cria um item fantasma e passa a exibir/marcar a opção errada —
 * na prática, o id cru no lugar do nome.
 */

export type SelectId = string | number | null | undefined

/** Comparador para `:value-comparator` — casa id numérico com id string. */
export const isSameId = (a: SelectId, b: SelectId): boolean => {
  if (a === null || a === undefined || b === null || b === undefined) return a === b
  return String(a) === String(b)
}

/** Normaliza o valor de um select para o id numérico que a API espera. */
export const toId = (v: SelectId): number | undefined => {
  if (v === null || v === undefined || v === '') return undefined
  const id = Number(v)
  return Number.isNaN(id) ? undefined : id
}
